export class ProductInfoSwatches extends ProductInfo {
  constructor() {
    super();
    this.isPDP = this.classList.contains("pdp");
    this.updateSwatchName();
  }

  updateSwatchName() {
    const swatches = this.querySelectorAll(".product--variations li");
    const currentSwatchLabel = this.querySelector(".current-swatch-color");
    const hoverSwatchLabel = this.querySelector(".hover-swatch-color");

    if (swatches)
      swatches.forEach((swatch) => {
        const swatchLabel = swatch.querySelector("label");
        const swatchName = swatchLabel.getAttribute("title");

        if (this.isPDP) {
          swatch.addEventListener("click", (e) => {
            e.preventDefault();
            const url = swatch.querySelector("a").href;
            window.location.replace(url);
          });
        }

        if (swatchName) {
          swatch.addEventListener("mouseenter", () => {
            if (currentSwatchLabel) currentSwatchLabel.style.display = "none";
            if (hoverSwatchLabel) hoverSwatchLabel.innerText = swatchName;
          });
          swatch.addEventListener("mouseleave", () => {
            if (currentSwatchLabel) currentSwatchLabel.style.display = "inline-block";
            if (hoverSwatchLabel) hoverSwatchLabel.innerText = "";
          });
        }
      });
  }
}
customElements.define("product-info-swatches", ProductInfoSwatches);
